import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { Card, Collapse } from "react-bootstrap";
import filterTypes from "data/filter-types";
import findFilterValue from "helpers/find-filter-value";
import searchOperationGenerator from "helpers/search-operation-generator";
import FilterItem from "views/lib/components/filter/filter-item";
import FilterHeader from "views/lib/components/filter/filter-header";
import { getFilters } from "actions/chargers/rent/actions";

const STATUSES = ["GARAGE", "TRANSFER", "SCOOTER"];

class Filers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      filters: {}
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleChangeFilter = this.handleChangeFilter.bind(this);

    this.props.getFilters();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.totalCount !== this.props.totalCount) {
      return true;
    } else if (nextState.isOpen !== this.state.isOpen) {
      return true;
    } else if (!_.isEqual(nextState.filters, this.state.filters)) {
      return true;
    } else if (!_.isEqual(nextProps.activeFilters, this.props.activeFilters)) {
      return true;
    } else if (!_.isEqual(nextProps.filters, this.props.filters)) {
      return true;
    }
    return false;
  }

  handleSearch = () => {
    const { filters } = this.state;
    const filtersToArray = [];
    Object.keys(filters)
      .forEach(name => {
        if (Object.keys(filters[name]).length) {
          filtersToArray.push(filters[name]);
        }
      });
    this.props.handleSearch(filtersToArray);
  };

  handleReset = () => {
    this.setState({
      filters: {}
    }, this.props.handleReset);
  };

  handleChangeFilter = (name, valueObject) => {
    const { filters } = this.state;
    filters[name] = valueObject;
    this.setState({
      filters
    });
  };

  render() {
    const {
      activeFilters,
      totalCount,
      filters,
    } = this.props;

    const { isOpen } = this.state;
    return (
      <Card className="w-100 mb-2 rounded-0">
        <FilterHeader
          title="PB Rent History"
          totalCount={totalCount}
          isOpen={isOpen}
          onToggle={(status) => this.setState({ isOpen: status })}
        />
        <Card.Body className="p-0">
          <Collapse in={isOpen} className="p-3" timeout={0}>
            <div className="row">
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="scooter"
                  placeholder="Scooter ID"
                  filterType="text"
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(filters.scooter)}
                  value={findFilterValue("scooter", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="scooterQr"
                  placeholder="Scooter QR"
                  filterType="text"
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(filters.scooterQr)}
                  value={findFilterValue("scooterQr", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="username"
                  placeholder="User email"
                  filterType="text"
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(filters.username)}
                  value={findFilterValue("username", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="from"
                  placeholder="Status From"
                  filterType="select"
                  filterTypeOptions={STATUSES.map(value => ({
                    label: value,
                    value
                  }))}
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(filters.status, [])}
                  value={findFilterValue("from", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="to"
                  placeholder="Status To"
                  filterType="select"
                  filterTypeOptions={STATUSES.map(value => ({
                    label: value,
                    value
                  }))}
                  onChange={this.handleChangeFilter}
                  searchOperation={searchOperationGenerator(filters.status, [])}
                  value={findFilterValue("to", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="date"
                  placeholder="Date"
                  filterType="date"
                  onChange={this.handleChangeFilter}
                  searchOperation={[filterTypes.MORE.value, filterTypes.LESS.value]}
                  value={findFilterValue("date", activeFilters)}
                />
              </div>

              <div className="col-12 col-md-3 mb-3 offset-3">
                <div className="d-flex justify-content-between justify-content-md-end">
                  <button
                    className="btn btn-warning btn-sm ml-2"
                    onClick={this.handleReset}
                  >
                    Reset
                  </button>
                  <button
                    className="btn btn-success btn-sm ml-2"
                    onClick={this.handleSearch}
                  >
                    Load
                  </button>
                </div>
              </div>
            </div>
          </Collapse>
        </Card.Body>
      </Card>
    );
  }
}

Filers.propTypes = {
  handleSearch: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  filters: state.powerBankRent.filters,
});

const mapStateToDispatch = dispatch => ({
  getFilters: bindActionCreators(getFilters, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Filers);



// WEBPACK FOOTER //
// ./src/views/pages/chargers/rent/filters.js